<air-search-bar-input
  [searchDisabled]="disabled"
  (searchFocus)="onFocus()"
  (searchBlur)="onBlur()"
  (searchInput)="onInput()"
  (searchKeyDown)="onKeyDown($event)"
  (searchClose)="onCancel()"
  (searchCancel)="onClose()"
>
</air-search-bar-input>
